import React from 'react';

import dayjs from "dayjs";

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import HolidayCreateModal from "./HolidayCreateModal";


class HolidayList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            holidays: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveHolidays();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveHolidays();
        }
    }

    async retrieveHolidays() {
        const url = 'holiday/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                holidays: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.holidays) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Праздники'}
                    url={'hr/holiday'}
                    data={this.state.holidays}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    extraComponents={[
                        {
                            component: HolidayCreateModal,
                            componentProps: {
                                callBack: this.retrieveHolidays.bind(this)
                            }
                        },
                    ]}
                    fields={
                        [
                            {
                                title: 'День',
                                name: 'day',
                                visible: true,
                                preProcess: (value) => (value?dayjs(value).format('DD.MM.YYYY'):value),
                            },
                        ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(HolidayList)